// extracted by mini-css-extract-plugin
export var actionButton = "_ag-1";
export var actionButtons = "_ag-2";
export var actions = "_ag-0";
export var aiUnread = "_ag-10";
export var alignCenter = "_ag-h";
export var backWrapper = "_ag-3";
export var cellContainer = "_ag-4";
export var checkboxContainer = "_ag-5";
export var contentContainer = "_ag-6";
export var contentHeader = "_ag-8";
export var conversationsTableWrapper = "_ag-s";
export var draftReplyBadgeContainer = "_ag-m";
export var dropdownItem = "_ag-b";
export var dropdownItemsContainer = "_ag-a";
export var dropdownTitle = "_ag-c";
export var errorIcon = "_ag-7";
export var filter = "_ag-d";
export var gray = "_ag-i";
export var headerActionButtons = "_ag-e";
export var headerCheckboxContainer = "_ag-f";
export var icon = "_ag-j";
export var menuContainer = "_ag-k";
export var noMoreTicketsIcon = "_ag-12";
export var noMoreTicketsSubText = "_ag-13";
export var oneLine = "_ag-l";
export var optionsButton = "_ag-n";
export var plus = "_ag-o";
export var portalButtonsWrapper = "_ag-g";
export var red = "_ag-p";
export var scrolledTop = "_ag-9";
export var search = "_ag-q";
export var selectedConversationsCount = "_ag-r";
export var spinner = "_ag-t";
export var strong = "_ag-u";
export var summaryCell = "_ag-v";
export var tableContainer = "_ag-11";
export var tagContainer = "_ag-w";
export var threeDots = "_ag-x";
export var twoLines = "_ag-y";
export var unread = "_ag-z";